var _filter, _pattern, _rect, _text, _text2, _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg04NatProblem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 900 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "natGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f59e0b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#d97706"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "privateNet",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1e3a5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0f172a"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "publicNet",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#134e4a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0d3d56"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadowNat",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 8,
    floodOpacity: 0.3
  }))), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "brickPattern",
    width: 20,
    height: 10,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10,
    fill: "#7c2d12"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 9,
    height: 5,
    fill: "#92400e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 9,
    height: 5,
    fill: "#92400e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 5,
    fill: "#b45309"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 9,
    height: 5,
    fill: "#b45309"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 500,
    fill: "#0f172a"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 40,
    textAnchor: "middle",
    fill: "#f8fafc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 24,
    fontWeight: "bold"
  }, "\n    NAT &amp; Firewall Problem\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 65,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14
  }, "\n    Private IPs are hidden from the public internet\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 280,
    rx: 16,
    fill: "url(#privateNet)",
    stroke: "#334155",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 30,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 600
  }, "\n      Private Network A\n    "), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65, 70)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -20,
    width: 60,
    height: 40,
    rx: 6,
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -15,
    width: 50,
    height: 25,
    rx: 4,
    fill: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("text", {
    y: 32,
    textAnchor: "middle",
    fill: "#93c5fd",
    fontFamily: "monospace",
    fontSize: 11
  }, "192.168.1.2")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(195, 70)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -20,
    width: 60,
    height: 40,
    rx: 6,
    fill: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -15,
    width: 50,
    height: 25,
    rx: 4,
    fill: "#4c1d95"
  }), /*#__PURE__*/React.createElement("text", {
    y: 32,
    textAnchor: "middle",
    fill: "#c4b5fd",
    fontFamily: "monospace",
    fontSize: 11
  }, "192.168.1.3")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130, 200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -30,
    width: 100,
    height: 60,
    rx: 10,
    fill: "url(#natGrad)",
    filter: "url(#shadowNat)"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "NAT"), /*#__PURE__*/React.createElement("text", {
    y: 45,
    textAnchor: "middle",
    fill: "#fcd34d",
    fontFamily: "monospace",
    fontSize: 11
  }, "Router")), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 115,
    x2: 65,
    y2: 160,
    stroke: "#475569",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 160,
    x2: 130,
    y2: 170,
    stroke: "#475569",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195,
    y1: 115,
    x2: 195,
    y2: 160,
    stroke: "#475569",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195,
    y1: 160,
    x2: 130,
    y2: 170,
    stroke: "#475569",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(610, 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 280,
    rx: 16,
    fill: "url(#privateNet)",
    stroke: "#334155",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 30,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 600
  }, "\n      Private Network B\n    "), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65, 70)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -20,
    width: 60,
    height: 40,
    rx: 6,
    fill: "#10b981"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -15,
    width: 50,
    height: 25,
    rx: 4,
    fill: "#064e3b"
  }), /*#__PURE__*/React.createElement("text", {
    y: 32,
    textAnchor: "middle",
    fill: "#6ee7b7",
    fontFamily: "monospace",
    fontSize: 11
  }, "192.168.1.5")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(195, 70)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -20,
    width: 60,
    height: 40,
    rx: 6,
    fill: "#ec4899"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -15,
    width: 50,
    height: 25,
    rx: 4,
    fill: "#831843"
  }), /*#__PURE__*/React.createElement("text", {
    y: 32,
    textAnchor: "middle",
    fill: "#f9a8d4",
    fontFamily: "monospace",
    fontSize: 11
  }, "192.168.1.6")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(130, 200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -30,
    width: 100,
    height: 60,
    rx: 10,
    fill: "url(#natGrad)",
    filter: "url(#shadowNat)"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "NAT"), /*#__PURE__*/React.createElement("text", {
    y: 45,
    textAnchor: "middle",
    fill: "#fcd34d",
    fontFamily: "monospace",
    fontSize: 11
  }, "Router")), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 115,
    x2: 65,
    y2: 160,
    stroke: "#475569",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 160,
    x2: 130,
    y2: 170,
    stroke: "#475569",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195,
    y1: 115,
    x2: 195,
    y2: 160,
    stroke: "#475569",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195,
    y1: 160,
    x2: 130,
    y2: 170,
    stroke: "#475569",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(320, 200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -80,
    width: 260,
    height: 160,
    rx: 12,
    fill: "url(#publicNet)",
    stroke: "#2dd4bf",
    strokeWidth: 2,
    strokeDasharray: "8,4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: -55,
    textAnchor: "middle",
    fill: "#5eead4",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600
  }, "\n      \uD83C\uDF10 PUBLIC INTERNET\n    "), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: -25,
    width: 80,
    height: 50,
    rx: 8,
    fill: "#0d9488"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "monospace",
    fontSize: 12
  }, "203.0.1.1"), /*#__PURE__*/React.createElement("text", {
    y: 20,
    textAnchor: "middle",
    fill: "#99f6e4",
    fontFamily: "system-ui, sans-serif",
    fontSize: 9
  }, "Public IP A")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(170, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: -25,
    width: 80,
    height: 50,
    rx: 8,
    fill: "#0d9488"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "monospace",
    fontSize: 12
  }, "198.51.2.2"), /*#__PURE__*/React.createElement("text", {
    y: 20,
    textAnchor: "middle",
    fill: "#99f6e4",
    fontFamily: "system-ui, sans-serif",
    fontSize: 9
  }, "Public IP B")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(295, 200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -50,
    width: 16,
    height: 100,
    fill: "url(#brickPattern)",
    rx: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 70,
    textAnchor: "middle",
    fill: "#f97316",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: "bold"
  }, "\uD83D\uDD25"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(605, 200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -50,
    width: 16,
    height: 100,
    fill: "url(#brickPattern)",
    rx: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 70,
    textAnchor: "middle",
    fill: "#f97316",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: "bold"
  }, "\uD83D\uDD25"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 350)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -100,
    y1: 0,
    x2: 100,
    y2: 0,
    stroke: "#ef4444",
    strokeWidth: 3,
    strokeDasharray: "10,5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;30",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    y: -15,
    textAnchor: "middle",
    fill: "#ef4444",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: "bold"
  }, "\n      \u274C Cannot connect directly!\n    "), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 15,
    fill: "#7f1d1d"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -6,
    y1: -6,
    x2: 6,
    y2: 6,
    stroke: "#ef4444",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: -6,
    x2: -6,
    y2: 6,
    stroke: "#ef4444",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 15,
    fill: "#7f1d1d"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -6,
    y1: -6,
    x2: 6,
    y2: 6,
    stroke: "#ef4444",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: -6,
    x2: -6,
    y2: 6,
    stroke: "#ef4444",
    strokeWidth: 3
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 435)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 55,
    rx: 10,
    fill: "#1e293b",
    stroke: "#475569",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 25,
    fill: "#f8fafc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#fbbf24",
    fontWeight: "bold"
  }, "Problem:"), " Devices have private IPs (192.168.x.x) that aren't routable on the public internet.\n    "), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 45,
    fill: "#94a3b8",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, "\n      NAT translates private IPs \u2192 public IPs, but the other peer doesn't know the mapping!\n    "))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg04NatProblem);
export default __webpack_public_path__ + "static/media/04-nat-problem.757817e4bf829859d59113764b6af3a5.svg";
export { ForwardRef as ReactComponent };